import { InjectionToken, Type } from '@angular/core';

export const PRIZM_MOBILE_CALENDAR = new InjectionToken<Type<unknown>>(`A component for mobile data picker`);
